import BaseModelAPI from '../BaseModelAPI';

export default class ReportTracingAbility extends BaseModelAPI {
	static entity = 'newreport2000';
	static entityName = 'reporttracingability';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.filterControlCard = '';
			this.filterTransactionType = '';
			this.filterCreatedDate = '';
			this.tempId = 0;
			this.controlCardType = '';
			this.controlCardNumber = '';
			this.partNumber = '';
			this.customerName = '';
			this.supplierCode = '';
			this.incomingDate = '';
			this.transactionDate = '';
			this.transactionType = '';
			this.qtyBefore = 0;
			this.qtyAfter = 0;
			this.rackBefore = '';
			this.rackAfter = '';
			this.areaBefore = '';
			this.areaAfter = '';
			this.sourceCase = '';
			this.statuss = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}